module.exports = __webpack_public_path__ + "static/img/Nuvio_Black.4a9a01f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/Nuvio_Black.png
// module id = 298
// module chunks = 33